import langUtil, { StringKey } from '@/utils/lang.util';
export const noLimitTime = -1;

export const itemList = {
  profile: 'profile',
  age: 'age',
  time: 'time',
  content: 'content',
  language: 'language',
  other: 'other',
};

export const ContentType = {
  Education: 'education',
  Music: 'music',
  Entertainment: 'entertainment',
  Mix: 'mix',
};

export const OtherTypes = {
  sound: 'sound',
  fullscreen: 'fullscreen',
  legal: 'legal',
  unsubscribe: 'unsubscribe',
  link: 'link',
};

export const LanguageCode = {
  English: 'en-US,en',
  French: 'fr-FR,fr',
  Spanish: 'es-ES,es',
  Portuguese: 'pt-PT,pt',
  Italian: 'it-IT,it',
  German: 'de-DE,de',
  Arabic: 'ar-AE,ar',
  Russian: 'ru-RU,ru',
  Dutch: 'nl-NL,nl',
};

const getTranslatedString = (string) => {
  return langUtil.getLang().t(string);
};

const getTimeList = () => [5, 20, 40, 60, 90, getTranslatedString(StringKey.SettingsNoLimit)];

const getAgeOptions = () => {
  return [
    {
      display: 'settings_3_5_years',
      value: { minAge: 3, maxAge: 5 },
      optionId: 1
    },
    {
      display: 'settings_6_8_years',
      value: { minAge: 6, maxAge: 8 },
      optionId: 2
    },
    {
      display: 'settings_3_8 years',
      value: { minAge: 3, maxAge: 8 },
      optionId: 3
    },
  ];
};

const convertedTimeOptions = (time) => {
  const displayTime = Number.isNaN(time) ? time : time + ' ' + getTranslatedString(StringKey.MinutesShort);
  return displayTime;
};

const getTimeOptions = (timeL) => {
  const list = [];
  for (let i = 0; i < timeL.length; i += 1) {
    const convertedTime = convertedTimeOptions(timeL[i]);
    const intValue = Number.isNaN(Number(timeL[i])) ? noLimitTime : timeL[i];
    const option = { optionId: i, display: convertedTime, value: intValue };
    list.push(option);
  }
  return list;
};

// Converted to function to prevent early access to StringKey
export const getContentOptions = () => [
  {
    optionId: 1,
    display: getTranslatedString(StringKey.SettingsContentTypeMix),
    value: 0
  },
  {
    optionId: 5,
    display: getTranslatedString(StringKey.SettingsContentTypeTopVideo),
    label: getTranslatedString(StringKey.SettingsContentTypeTopVideo),
    value: 5,
    icon: 'star'
  },
  {
    optionId: 2,
    display: getTranslatedString(StringKey.SettingsContentTypeFun),
    label: getTranslatedString(StringKey.SettingsContentTypeFun),
    value: 1,
    icon: 'cartoon'
  },
  {
    optionId: 3,
    display: getTranslatedString(StringKey.SettingsContentTypeLearn),
    label: getTranslatedString(StringKey.SettingsContentTypeLearn),
    value: 2,
    icon: 'education'
  },
  {
    optionId: 4,
    display: getTranslatedString(StringKey.SettingsContentTypeMusic),
    label: getTranslatedString(StringKey.SettingsContentTypeMusic),
    value: 4,
    icon: 'music'
  },
];

// Converted to function to prevent early access to StringKey
export const getContentCardsOptions = () => [
  {
    id: 5,
    label: getTranslatedString(StringKey.SettingsContentTypeTopVideo),
    value: 5,
    icon: 'star'
  },
  {
    id: 2,
    label: getTranslatedString(StringKey.SettingsContentTypeFun),
    value: 1,
    icon: 'cartoon'
  },
  {
    id: 3,
    label: getTranslatedString(StringKey.SettingsContentTypeLearn),
    value: 2,
    icon: 'education'
  },
  {
    id: 4,
    label: getTranslatedString(StringKey.SettingsContentTypeMusic),
    value: 4,
    icon: 'music'
  },
];

// Converted to function to prevent early access to StringKey
export const getOthersOptions = () => [
  {
    optionId: 1,
    display: getTranslatedString(StringKey.SettingsMiscMusicSound),
    value: OtherTypes.sound,
    play: true,
  },
  {
    optionId: 2,
    display: getTranslatedString(StringKey.SettingsMiscFullscreen),
    value: OtherTypes.fullscreen,
  },
  {
    optionId: 3,
    display: getTranslatedString(StringKey.SettingsMiscGcu),
    value: OtherTypes.legal,
  },
  {
    optionId: 4,
    display: 'Account',
    type: 'link',
    value: OtherTypes.link,
  },
];

const getLanguesOptions = () => [
  {
    optionId: 1,
    display: getTranslatedString(StringKey.SettingsLanguageEnglish),
    value: 1,
    codeLang: LanguageCode.English,
  },
  {
    optionId: 2,
    display: getTranslatedString(StringKey.SettingsLanguageSpanish),
    value: 27,
    codeLang: LanguageCode.Spanish,
  },
  {
    optionId: 3,
    display: getTranslatedString(StringKey.SettingsLanguageFrench),
    value: 34,
    codeLang: LanguageCode.French,
  },
  {
    optionId: 4,
    display: getTranslatedString(StringKey.SettingsLanguagePortuguese),
    value: 89,
    codeLang: LanguageCode.Portuguese,
  },
  {
    optionId: 5,
    display: getTranslatedString(StringKey.SettingsLanguageItalian),
    value: 51,
    codeLang: LanguageCode.Italian,
  },
  {
    optionId: 6,
    display: getTranslatedString(StringKey.SettingsLanguageGerman),
    value: 23,
    codeLang: LanguageCode.German,
  },
  {
    optionId: 7,
    display: getTranslatedString(StringKey.SettingsLanguageArabic),
    value: 6,
    codeLang: LanguageCode.Arabic,
  },
  {
    optionId: 8,
    display: getTranslatedString(StringKey.SettingsLanguageRussian),
    value: 94,
    codeLang: LanguageCode.Russian,
  },
  {
    optionId: 9,
    display: getTranslatedString(StringKey.SettingsLanguageDutch),
    value: 82,
    codeLang: LanguageCode.Dutch,
  },
];

const getItem = (itemType, title, list) => {
  const dataItem = { itemType, title, options: list };
  return dataItem;
};

// This function now builds the list dynamically when called
export const getSettingOptionList = () => [
  getItem(itemList.profile, '', []),
  getItem(itemList.age, getTranslatedString(StringKey.SettingsAge), getAgeOptions()),
  getItem(itemList.time, getTranslatedString(StringKey.SettingsTimeLimit), getTimeOptions(getTimeList())),
  getItem(itemList.content, getTranslatedString(StringKey.SettingsContentType), getContentOptions()),
  getItem(itemList.language, getTranslatedString(StringKey.SettingsLanguage), getLanguesOptions()),
  getItem(itemList.other, getTranslatedString(StringKey.SettingsMisc), getOthersOptions()),
];

export default getSettingOptionList;